import {CHECKOUT, OPEN_ORDERS} from 'new-constants/navigation.constants';
import {MINICART_POPUP} from 'compositions/minicart/Minicart';
import {OPEN_ORDER} from "../constants/navigation.constants";
import {trackEvent} from "../helpers/tracking.helpers";
import {GUEST_ORDER_POPUP} from "new-constants/popup.constants";

export const openOrders = (restaurantId) => {
	trackEvent({
		event: 'Open Orders',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: OPEN_ORDERS,
	};
};

export const checkout = (restaurantId) => {
	trackEvent({
		event: 'Page View Checkout',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: CHECKOUT,
		hidePopups: [MINICART_POPUP, GUEST_ORDER_POPUP],
	};
};

export const openOrder = (orderId) => {
	trackEvent({
		event: 'Open Order',
		properties: {
			'Order Id': orderId,
		}
	});
	return {
		type: OPEN_ORDER,
		orderId
	}
}
